export const ECarrierStates = {
	ACTIVE: 'ACTIVE',
	INACTIVE: 'INACTIVE',
	SLEEP: 'SLEEP',
} as const;
